import { render, staticRenderFns } from "./RelatedActivity.vue?vue&type=template&id=2982ea60&scoped=true&"
import script from "./RelatedActivity.vue?vue&type=script&lang=js&"
export * from "./RelatedActivity.vue?vue&type=script&lang=js&"
import style0 from "./RelatedActivity.vue?vue&type=style&index=0&id=2982ea60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2982ea60",
  null
  
)

export default component.exports